export const REQUEST="REQUEST";
export const GET_SUCCESS="GET_SUCCESS";
export const FAILED="FAILED";